module.exports = __webpack_public_path__ + "32f95a4b3e3d909ec3d5c37208f55d5d.ttf";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-SemiBold.ttf
// module id = 370
// module chunks = 0